export const GET_GAME_HISTORY = "GET_GAME_HISTORY"
export const GET_GAME_STATS = "GET_GAME_STATS"
export const RESET_COIN = "RESET_COIN"